exports = module.exports = require("../../../../../../web-hosted/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".SingleTaskStatusPage__SingleTaskStatusPageContainer__3M-hB {\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n}\n\n.SingleTaskStatusPage__TaskNotExistsContainer__1tvia {\n  font-size: 18px;\n  width: 100%;\n  height: 50%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n}", ""]);

// exports
exports.locals = {
	"SingleTaskStatusPageContainer": "SingleTaskStatusPage__SingleTaskStatusPageContainer__3M-hB",
	"TaskNotExistsContainer": "SingleTaskStatusPage__TaskNotExistsContainer__1tvia"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../shared-components/src/containers/Mainpage/containers/SingleTaskStatusPage/SingleTaskStatusPage.css
// module id = 860
// module chunks = 0